import checkSnippets from "./checkSnippets";
import replaceSnippets from "./replaceSnippets";

export default async function prepareMessage(client, folder, message) {
  let formattedMessage;
  const messagesFormatted = [];

  const snippets = await checkSnippets(message);

  for (const channel of folder.channels) {
    if (snippets.length !== 0) {
      formattedMessage = await replaceSnippets(
        message,
        snippets,
        channel,
        client,
      );
    } else {
      formattedMessage = message;
    }
    messagesFormatted.push(formattedMessage);
  }
  return messagesFormatted;
}
